import { Typography } from "@mui/material";
import Grid from '@mui/material/Grid';
import { OrderWithItems } from 'common-models';

import { FC, useEffect, useState } from "react";
import { useGetOrderQuery } from "../../features/events/eventShopApiSlice";
import PageIsLoading from "../PageIsLoading";
import { PaymentCompletedView } from "./PaymentCompletedView";
import { PaymentFailedView } from "./PaymentFailedView";
import { SwishPaymentIndexView } from "./Swish/SwishPaymentIndexView";

type PaymentViewProps = {
    orderId: string,
    setCurrentPaymentStep: (currentStep: number) => void
}

const PaymentView: FC<PaymentViewProps> = ({ orderId, setCurrentPaymentStep }) => {

    // API CALLS
    const { data = undefined as unknown as OrderWithItems } = useGetOrderQuery(orderId);

    const [order, setOrder] = useState(undefined as unknown as OrderWithItems);

    useEffect(() => {
        if (data !== undefined) {
            // console.info(data);
            setOrder(data);
        }
    }, [data])

    useEffect(() => {
        if (order) {
            switch (order.currentState) {
                case 'PaymentInProgress':
                case 'Failed':
                    setCurrentPaymentStep(1);
                    break;
                case 'Completed':
                    setCurrentPaymentStep(2);
                    break;
            }
        }
    }, [order, setCurrentPaymentStep])

    function getPaymentComponent(order: OrderWithItems) {
        switch (order.currentState) {
            case 'PaymentInProgress':
                return <SwishPaymentIndexView order={order} />

            case 'Completed':
                return <PaymentCompletedView order={order} />

            case 'Failed':
                return <PaymentFailedView order={order} />
            default:
                break;
        }
    }

    function getSumIncludingVat(input: number): number {
        return input * 1.25;
    }

    return (
        <>
            {
                order === undefined ? (
                    <PageIsLoading />
                ) : (
                    <>
                        <Grid container>
                            <Typography component={"h2"} variant="h2">
                                {" "}
                                Total: SEK {getSumIncludingVat(order.totalSum)}
                            </Typography>
                        </Grid>
                        <Grid
                            container
                            className='cart-items-container'>
                            {getPaymentComponent(order)}
                        </Grid>
                    </>
                )
            }
        </>
    );
    // }
};

export { PaymentView };
